import { render, staticRenderFns } from "./AccountAuth.vue?vue&type=template&id=12399f47&scoped=true"
import script from "./AccountAuth.vue?vue&type=script&lang=js"
export * from "./AccountAuth.vue?vue&type=script&lang=js"
import style0 from "./AccountAuth.vue?vue&type=style&index=0&id=12399f47&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "12399f47",
  null
  
)

export default component.exports